import { AppTranslateState } from './app-translate.interfaces';

export const defaultAppTranslateState: AppTranslateState = {
    activeLanguage: null,
    datepickerTranslations: null,
    languages: [],
};
